const endpoints = {
  GET_SERVICES: "/services/",
};

export default endpoints;
